import { AccountStatus, IAccount } from "../../models/account/IAccount";
import StatusPill, { StatusPillColour } from "../shared/StatusPill";

interface HauliersTableProps {
  accounts: IAccount[];
  onOpen: (account: IAccount) => void;
}

// Accounts flagged as hauliers. Clicking through lands on the account page, where contacts,
// addresses and the Waste Movements history live.
export default function HauliersTable({ accounts, onOpen }: HauliersTableProps) {
  if (accounts.length === 0) {
    return (
      <div className="mt-4 rounded-lg bg-white p-8 text-center text-sm text-gray-500 shadow">
        No hauliers yet. Add one, or tick &quot;Waste carrier (haulier)&quot; on an existing account, and it will appear in
        the Waste Tracking haulier dropdown.
      </div>
    );
  }

  return (
    <div className="mt-4 overflow-auto rounded-lg bg-white shadow">
      <table className="min-w-full divide-y divide-gray-300">
        <thead>
          <tr className="bg-primary-50 text-gray-800">
            <th scope="col" className="px-3 py-3.5 text-left text-sm font-semibold">Account no.</th>
            <th scope="col" className="px-3 py-3.5 text-left text-sm font-semibold">Haulier</th>
            <th scope="col" className="px-3 py-3.5 text-left text-sm font-semibold">Carrier reg no.</th>
            <th scope="col" className="px-3 py-3.5 text-left text-sm font-semibold">Usual vehicle reg</th>
            <th scope="col" className="px-3 py-3.5 text-left text-sm font-semibold">Status</th>
          </tr>
        </thead>
        <tbody className="divide-y divide-gray-200">
          {accounts.map((account) => (
            <tr key={account.id} className="cursor-pointer hover:bg-gray-50" onClick={() => onOpen(account)}>
              <td className="px-3 py-3 text-sm text-gray-700">{account.accountNumber || "N/A"}</td>
              <td className="px-3 py-3 text-sm font-medium text-gray-900">{account.name}</td>
              <td className="px-3 py-3 text-sm font-mono text-gray-900">
                {account.carrierRegistrationNumber ?? <span className="text-red-600">Missing</span>}
              </td>
              <td className="px-3 py-3 text-sm text-gray-700">
                {account.haulierVehicleRegistration ?? <span className="text-gray-400">-</span>}
              </td>
              <td className="px-3 py-3 text-sm">
                {account.status === AccountStatus.Enabled ? (
                  <StatusPill text="Enabled" colour={StatusPillColour.Green} />
                ) : account.status === AccountStatus.Disabled ? (
                  <StatusPill text="Disabled" colour={StatusPillColour.Neutral} />
                ) : (
                  <StatusPill text="Archived" colour={StatusPillColour.Neutral} />
                )}
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}
